import Alpine from "alpinejs";
import IMask from "imask";
import { openModal } from "./components/modal.js";
import { initializeScrollToTopButton } from "./components/up.js";

// --- Alpine.js ---
window.Alpine = Alpine;
Alpine.start();

// --- Модалки ---
function attachModals() {
  document.querySelectorAll("[data-target]").forEach(function (button) {
    if (button.onclick == null) {
      const modalTarget = button.getAttribute("data-target");
      button.onclick = function () {
        openModal(modalTarget);
      };
    }
  });
}

window.addEventListener("load", attachModals);

// --- Scroll to top ---
// if (document.querySelector(".btn-slide-up")) {
//   window.addEventListener("DOMContentLoaded", function () {
//     initializeScrollToTopButton(".btn-slide-up", 300, 200);
//   });
// }

// --- Dropdown hover (десктоп) ---
const viewport = Math.max(document.documentElement.clientWidth, window.innerWidth);
if (viewport > 991) {
  document.querySelectorAll("ul.main-menu li.dropdown").forEach(function (li) {
    let hideTimeout;

    li.addEventListener("mouseenter", function () {
      clearTimeout(hideTimeout);
      li.classList.add("open");
      const menu = li.querySelector(".dropdown-menu");
      if (menu) {
        menu.style.display = "block";
        menu.style.opacity = "1";
      }
    });

    li.addEventListener("mouseleave", function () {
      hideTimeout = setTimeout(function () {
        li.classList.remove("open");
        const menu = li.querySelector(".dropdown-menu");
        if (menu) {
          menu.style.display = "none";
          menu.style.opacity = "0";
        }
      }, 200);
    });
  });
}

// --- Drupal behaviors & Drupal.Ajax ---
(function (Drupal, once) {
  Drupal.behaviors.tiun_js = {
    attach: function (context) {
      attachModals();
      cartBlockClass();

      // Закриття статусних повідомлень
      once("messages-close", ".messages__close", context).forEach(function (btn) {
        btn.addEventListener("click", function () {
          btn.closest(".messages").remove();
        });
      });
    },
  };

  // Відкриття модалки кошика при додаванні товару —
  // хук в Drupal.Ajax.prototype замість jQuery ajaxSend/ajaxSuccess
  if (typeof Drupal.Ajax !== "undefined") {
    // Патч конструктора: при створенні Drupal.Ajax інстансу додаємо URL
    // до ajaxTrustedUrl. Верифікація (ajax.js:570) перевіряє ajax.url
    // проти ajaxTrustedUrl ДО виклику prototype.success — тому треба
    // додавати URL якомога раніше (при створенні інстансу, а не при запиті).
    const OrigDrupalAjax = Drupal.Ajax;
    Drupal.Ajax = function (base, element, element_settings) {
      OrigDrupalAjax.apply(this, arguments);
      if (this.url && this.url.indexOf("/views/ajax") !== -1 && drupalSettings.ajaxTrustedUrl) {
        drupalSettings.ajaxTrustedUrl[this.url] = true;
      }
    };
    Drupal.Ajax.prototype = OrigDrupalAjax.prototype;
    Drupal.Ajax.prototype.constructor = Drupal.Ajax;

    const origBeforeSubmit = Drupal.Ajax.prototype.beforeSubmit;
    Drupal.Ajax.prototype.beforeSubmit = function (formValues, element, options) {
      var triggerValue = options && options.data && options.data._triggering_element_value;
      if (triggerValue && /^(В корзину|У кошик|Купити|Купить)$/.test(triggerValue)) {
        this._tiunCartAdd = true;
      }
      if (origBeforeSubmit) {
        return origBeforeSubmit.apply(this, arguments);
      }
    };

    // Перехоплюємо AJAX-помилки щоб не було Uncaught Drupal.AjaxError
    // (наприклад, при швидкій зміні слайдера ціни — попередній запит абортується)
    const origError = Drupal.Ajax.prototype.error;
    Drupal.Ajax.prototype.error = function (xmlhttprequest, uri, customMessage) {
      try {
        return origError.apply(this, arguments);
      } catch (e) {
        console.warn("Drupal AJAX error:", uri, e.message);
      }
    };

    const origSuccess = Drupal.Ajax.prototype.success;
    Drupal.Ajax.prototype.success = function (response, status) {
      var isCartAdd = this._tiunCartAdd;
      this._tiunCartAdd = false;
      var result = origSuccess.apply(this, arguments);
      if (isCartAdd) {
        if (result && typeof result.then === "function") {
          result.then(function () {
            openModal("#cart-ajax-modal");
          });
        } else {
          openModal("#cart-ajax-modal");
        }
      }
      return result;
    };
  }

  // .cart-is-empty клас для стилізації тогглера кошика
  function cartBlockClass() {
    const toggler = document.querySelector(".cart--cart-block");
    const countEl = document.querySelector(".cart-block--summary__count i");
    if (toggler && countEl) {
      toggler.classList.toggle("cart-is-empty", parseInt(countEl.textContent) === 0);
    }
  }

  cartBlockClass();

  // Маска телефону — imask.js
  function applyPhoneMasks() {
    document.querySelectorAll('[type="tel"]').forEach(function (input) {
      if (input.dataset.imaskApplied) return;
      IMask(input, {
        mask: "+{380}(00) 000-00-00",
        lazy: false,
      });
      input.dataset.imaskApplied = "1";
      input.setAttribute(
        "oninvalid",
        "this.setCustomValidity(Drupal.t('Enter your phone number'))",
      );
      input.setAttribute("oninput", "setCustomValidity('')");
    });
  }

  window.addEventListener("load", applyPhoneMasks);

  Drupal.behaviors.tiun_phone_mask = {
    attach: function () {
      applyPhoneMasks();
    },
  };

  Drupal.attachBehaviors();
})(Drupal, once);

// "Товари у Кошику" (число) для /basket/
(function (Drupal) {
  function syncCartCount() {
    const src = document.querySelector(".cart-block--summary__count");
    const dst = document.querySelector(".cart-block__count");
    if (src && dst) dst.textContent = src.textContent;
  }

  // BigPipe вставляє блок кошика асинхронно — спостерігаємо за body,
  // щоб зловити момент появи елемента в DOM.
  function watchForCartBlock() {
    if (document.querySelector(".cart-block--summary__count")) {
      syncCartCount();
      return;
    }
    const observer = new MutationObserver(function () {
      if (document.querySelector(".cart-block--summary__count")) {
        syncCartCount();
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", watchForCartBlock);

  // Drupal.behaviors — спрацює після BigPipe-inject та після кожного AJAX
  Drupal.behaviors.cartCountSync = {
    attach() {
      syncCartCount();
    },
  };
})(Drupal);

// "Відкладені товари" (число) для /basket/
(function (Drupal) {
  function syncWishlistCount() {
    const src = document.querySelector(".wishlist-block__count.header-ico__count");
    const dst = document.querySelector(".wishlist-block__count:not(.header-ico__count)");
    if (src && dst) dst.textContent = src.textContent;
  }

  Drupal.behaviors.wishlistCountSync = {
    attach() {
      syncWishlistCount();
    },
  };
})(Drupal);
